import { motion, useReducedMotion } from "framer-motion";

const variants = {
  hidden: { opacity: 0, y: 22 },
  visible: (delay = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.66, ease: [0.22, 0.61, 0.36, 1], delay },
  }),
};

/**
 * Entrada suave ao rolar. Usa `once` para não repetir a animação
 * e não competir com a leitura.
 *
 * Com `prefers-reduced-motion` o conteúdo é renderizado direto, sem
 * animação — nunca dependendo dela para ficar visível.
 */
export function Reveal({ children, delay = 0, amount = 0.2, className, as = "div" }) {
  const reduceMotion = useReducedMotion();
  const Component = motion[as] || motion.div;
  const Static = as;

  if (reduceMotion) {
    return <Static className={className}>{children}</Static>;
  }

  return (
    <Component
      className={className}
      variants={variants}
      custom={delay}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount }}
    >
      {children}
    </Component>
  );
}
